import React, { useState, useEffect, useRef } from 'react';
import './Tools-and-resources.css';
import HeaderMenu from "../../Header/header-menu";
import Header from "../../Header/header";
import Footer from "../../Footer/Footer";
import Isi from "../../ISI/Isi";
import IsiFrame from "../../ISI/Isi-frame";
import NavigationBar from "../../NavigationBar/NavigationBar";
import Brochure from '../../Brochure/Brochure';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import MainLayout from '../../Layouts/Main_Layout';


export default function ToolsAndResources() {
  const myRef = useRef(null)
  const navigate = useNavigate();

  const [show, setShow] = useState(true)

  const executeScroll = () => {
    myRef.current.scrollIntoView();
    setShow(true)
  }

  const getChromeVersion = () => {
    var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
    if (raw) {
      return parseInt(raw[2], 10);
    }
    else {
      return 100;
    }
  }

  const handleVideoClick = (eventType, clickClass) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag('event', eventType, {
        'event_category': 'video_play',
        'event_label': clickClass,
        'page_location': window.location.href
      });
    }
  }

  useEffect(() => {
    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY - 300 > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);


        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }
    };
    calculateOffset();
    window.addEventListener('resize', calculateOffset);

    return () => {
      window.removeEventListener('resize', calculateOffset);
    };
  }, []);

  const handleDDGPdf = () => {
    var pdfFile = '/pdfs/doctor-discussion-guide.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      pdfFile = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + pdfFile);

    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const handleHelpfulPdf = () => {
    var pdfFile = '/pdfs/helpful-hints.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      pdfFile = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + pdfFile);

    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const handlePatientBrochure = () => {
    var pdf_file = '/pdfs/patient-brochure.pdf';
    if (window.location.pathname.includes('informacion-en-espanol')) {
      pdf_file = '/pdfs/guia-de-conversacion-con-medicos.pdf';
    }
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const myUrlWithParams = new URL(window.location.protocol + '//' + window.location.hostname + pdf_file);

    if (urlParams.get('utm_campaign')) {
      myUrlWithParams.searchParams.append('utm_campaign', urlParams.get('utm_campaign'));
    }
    if (urlParams.get('utm_medium')) {
      myUrlWithParams.searchParams.append('utm_medium', urlParams.get('utm_medium'));
    }
    if (urlParams.get('utm_source')) {
      myUrlWithParams.searchParams.append('utm_source', urlParams.get('utm_source'));
    }
    if (urlParams.get('utm_content')) {
      myUrlWithParams.searchParams.append('utm_content', urlParams.get('utm_content'));
    }
    window.open(myUrlWithParams);
  }

  const DisbableClick = () => {
    if (getChromeVersion() < 60) {
      return "disable-link-click"
    }
    else {
      return ""
    }
  }

  return (
    <MainLayout>
      <div className='tools-and-resources'>
        <Helmet>
          <title>Tools and Resources | INBRIJA® (levodopa inhalation powder)</title>
          <meta property='og:title' content={`Tools and Resources | INBRIJA® (levodopa inhalation powder)`} />
          <meta property='og:description' content={`Use the INBRIJA Resource Center for tools and resources alongside guidance from your doctor.`} />
          <meta property='og:site_name' content='INBRIJA.COM' />
          <meta property='og:type' content='website' />
          <meta name='description' content={`Use the INBRIJA Resource Center for tools and resources alongside guidance from your doctor.`} />
          <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
          <meta property='og:url' content='https://inbrija.com/tools-and-resources' />
          <meta property='og:image:alt' content='INBRIJA logo' />
        </Helmet>
        <Header />
        <HeaderMenu>
          <div className="container">
            <div className="inbrija-stories-header">
              <h1>The INBRIJA Resource Center offers tools and resources to <span>help you</span></h1>
              <h6>The more you know about the return of Parkinson&rsquo;s disease (PD) symptoms (Also known as OFF Episodes) and your medication, the more your doctor can help you manage them.</h6>
            </div>
          </div>
        </HeaderMenu>
        <div className="brush-style">   </div>
       
        <div className='resources-section'>
          <div className='resources-container-title'>
            <h2 className='resources-section-heading'>Resources you can use to fight back</h2>
          </div>
          <div className='resources-container-download'>
            <div className='people-brochure'>
              <Brochure src1="/assets/images/brochure-jimmy.webp" src="/assets/images/brochure-jimmy-mobile.webp" alt="Head shot of real INBRIJA patient">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>Real INBRIJA Stories</div>
                  <div className='brochure-content'>Watch videos from carepartners and real people with PD who use INBRIJA to fight symptoms when they return.</div>
                </div>
                <button className='brochure-button' id='TR_watch_stories' onClick={() => navigate('/inbrija-stories')}>See INBRIJA Stories</button>
              </Brochure>
              <Brochure src1="/assets/images/brochure-drconversationstarter.webp" src="/assets/images/brochure-drconversationstarter-mobile.webp" alt="Screenshot of Doctor Discussion Guide">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>Doctor Conversation Starters for Your Next Visit</div>
                  <div className='brochure-content'>Your doctor is in your corner in your fight against returning PD symptoms; the Doctor Discussion Guide will help you communicate more effectively with them.</div>
                </div>
                <button onClick={handleDDGPdf} className='ddg-button' id='TR_talking_doctor'>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 10L14 12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14L3.33333 14C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667L2 10" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.66602 6.66699L7.99935 10.0003L11.3327 6.66699" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8 10L8 2" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>Download</button>
              </Brochure>
              <Brochure src="/assets/images/brochure-intro-inbrija-mobile.webp" src1="/assets/images/brochure-intro-inbrija.webp" alt="Screenshot of INBRIJA brochure">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>INBRIJA Brochure</div>
                  <div className='brochure-content'>Get an introduction to INBRIJA and how it works to fight returning symptoms.</div>
                </div>
                <button onClick={handlePatientBrochure} className={`brochure-button patient-brochure ${DisbableClick()}`} target="_blank" rel="noreferrer" id='TR_brochure'>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 10L14 12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14L3.33333 14C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667L2 10" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.66602 6.66699L7.99935 10.0003L11.3327 6.66699" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8 10L8 2" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>Download</button>
              </Brochure>
              <Brochure src1="/assets/images/brochure-updates.webp" src="/assets/images/brochure-updates-mobile.webp" alt="A man and woman looking at a computer together">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>Get Updates on INBRIJA</div>
                  <div className='brochure-content'>Sign up to have updates and information about INBRIJA sent straight to your inbox.</div>
                </div>
                <button className='brochure-button' onClick={() => navigate('/sign-up')} id='TR_sign_up'>Sign Up</button>
              </Brochure>
              <Brochure src1="/assets/images/brochure-demonstation.webp" src="/assets/images/brochure-demonstation-mobile.webp" alt="Head shot of animated figure, Peter">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>INBRIJA Demonstration Video</div>
                  <div className='brochure-content'>A step-by-step training video for using the INBRIJA inhaler.</div>
                </div>
                <button className='brochure-button ask-peter-video-demo' onClick={() => { navigate('/how-to-use-inbrija#peter-demo'); handleVideoClick('demo_video', 'TR_watch_peter_demo') }}>Watch Video</button>
              </Brochure>
              <Brochure src1="/assets/images/brochure-helpful-1.png" src="/assets/images/helpful-hints-mobile-1.png" alt="Helpful Hints screenshot">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>Helpful Hints for Using INBRIJA</div>
                  <div className='brochure-content'>Tips to help get you up to speed on using INBRIJA.</div>
                </div>
                <button onClick={handleHelpfulPdf} className={`helpful-hints-button absolute ${DisbableClick()}`} target="_blank" rel="noreferrer" id='TR_helpful_hints'>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 10L14 12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14L3.33333 14C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667L2 10" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.66602 6.66699L7.99935 10.0003L11.3327 6.66699" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8 10L8 2" stroke="#AE9BC3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>Download</button>
              </Brochure>
              <Brochure src1="/assets/images/brochure-ask-peter.webp" src="/assets/images/brochure-ask-peter-mobile.webp" alt="Close shot of animated figure, Peter, using INBRIJA inhaler">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>Just Ask Peter<sup className='sm-text-white'>SM</sup></div>
                  <div className='brochure-content'>Think of Peter as a kind of INBRIJA coach—watch these videos to get the answers to many of the INBRIJA questions we know people with PD have.</div>
                </div>
                <button className='brochure-button just-ask-peter-video-button' onClick={() => navigate('/common-questions#peter-videos')} id='TR_watch_peter'>Watch Videos</button>
              </Brochure>
              <Brochure src="/assets/images/brochure-common-ques-mobile.webp" src1="/assets/images/brochure-common-ques.webp" alt="Screenshots taken from several Peter instructional videos">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>Common Questions</div>
                  <div className='brochure-content'>Check out this list of frequently asked questions and answers.</div>
                </div>
                <button className='brochure-button float-right' onClick={() => navigate('/common-questions#faqs')} id='TR_common_questions'>Common Questions</button>
              </Brochure>
              <Brochure src="/assets/images/tools-nurse-educator-mobile.png"  src1="/assets/images/tools-nurse-educator.png" alt="Smiling nurse educator on yellow background">
                <div className='brochure-heading-content'>
                  <div className='brochure-heading'>Nurse Educators</div>
                  <div className='brochure-content'>
                    <div>
                      Nurse Educators are on call to help you gain confidence using your INBRIJA. You may contact them at <span className="text-nowrap">1-833-INBRIJA</span>
                    </div>
                    <div className="mt-4">
                      Paid by Merz Therapeutics. Not affiliated with INBRIJA prescribers.
                    </div>
                  </div>
                </div>
                <button className='brochure-button float-right' onClick={() => navigate('/for-people-on-inbrija')} id='TR_nurse_educators'>Schedule a Call</button>
              </Brochure>
            </div>
            <div className='org-help-container'>
              <div className='org-help-container-title'>
                <div className='container'>
                  <h2>Connect with organizations that support people living with Parkinson&rsquo;s disease</h2>
                  <h3>Learn more about organizations that provide education, resources, and community support for people living with Parkinson&rsquo;s disease and their care partners. This is not an exhaustive list of available resources.</h3>
                </div>
              </div>
              <div className='org-help-container-list'>
                <div className="container">
                  <ul className="row">
                    <li className="col-6 text-center mb-3">
                      <a href="https://www.apdaparkinson.org/" target="_blank" rel="noreferrer" id="TR_APDA">
                        American Parkinson&rsquo;s Disease Association
                      </a>
                    </li>
                    <li className="col-6 text-center mb-3">
                      <a href='https://www.michaeljfox.org/' target="_blank" rel="noreferrer" id='TR_MJF'>
                        Michael J. Fox Foundation
                      </a>
                    </li>
                    <li className="col-6 text-center mb-3">
                      <a href='https://caregiveraction.org/' target="_blank" rel="noreferrer" id='TR_CAN'>
                        Caregiver Action Network
                      </a>
                    </li>
                    <li className="col-6 text-center mb-3">
                      <a href='https://www.davisphinneyfoundation.org/' target="_blank" rel="noreferrer" id='TR_DP'>
                        Davis Phinney Foundation for Parkinson&rsquo;s
                      </a>
                    </li>
                    <li className="col-6 text-center mb-3">
                      <a href='http://www.parkinson.org/' target="_blank" rel="noreferrer" id='TR_PF'>
                        Parkinson&rsquo;s Foundation
                      </a>
                    </li>
                    <li className="col-6 text-center mb-3">
                      <a href='https://www.pmdalliance.org/' target="_blank" rel="noreferrer" id='TR_PMD'>
                        Parkinson & Movement Disorder Alliance
                      </a>
                    </li>
                  </ul>
                  <p className="small">The organizations listed are independent third parties. Inclusion of these organizations does not imply endorsement by INBRIJA, nor does it imply endorsement of INBRIJA by these organizations.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <NavigationBar
          leftNavigation="Watch INBRIJA in Action"
          leftNavigationLink="/inbrija-stories"
          leftNavigationid="TR_watch_stories"
          rightNavigation="Prepare for Discussions With Your Doctor"
          rightNavigationLink="/about-inbrija#talking-with-doctor"
          rightNavigationid="TR_talking_doctor"
        />
        <div ref={myRef}>
          <Isi />
        </div>
        {show ?
          <IsiFrame onClick={executeScroll} /> : ''}
        <Footer year="2025" partNum="01/25 US-INB-2500205"
          facebookLink="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fwww.inbrija.com%2Ftools-resources&title=INBRIJA%20Tools%20and%20Resources&description=Find%20helpful%20tools%20and%20resources."
          twitterCode="https://twitter.com/intent/tweet?text=INBRIJA%20Tools%20and%20Resources.%20Find%20helpful%20tools%20and%20resources.%20https://www.inbrija.com/tools-resources"
          title="Tools and Resources | INBRIJA® (levodopa inhalation powder)"
        />
      </div>
    </MainLayout>
  )
}